import useSWR, { SWRResponse } from "swr";

import {
  GetRestrictedStreamingKeyResponse,
  getRestrictedStreamingKey,
} from "api/schema/stream/getRestrictedStreamingKey";
import { useStreamApiClient } from "api/useSpwnApiClient";

const generateKey = ({
  eventId,
  videoId,
  code,
}: {
  eventId: string;
  videoId: string;
  code: string;
}) => ({
  path: getRestrictedStreamingKey.path,
  eventId,
  videoId,
  code,
});

type UseGetRestrictedStreamingKey = (args: {
  eventId?: string;
  videoId?: string;
  code?: string;
}) => SWRResponse<GetRestrictedStreamingKeyResponse>;

export const useGetRestrictedStreamingKey: UseGetRestrictedStreamingKey = ({
  eventId,
  videoId,
  code,
}) => {
  const apiClient = useStreamApiClient();
  return useSWR(
    // 必須パラメータが揃わない場合は fetch しない（未指定での無効化を意図した呼び出しに対応）
    eventId && videoId && code
      ? generateKey({
          eventId,
          videoId,
          code,
        })
      : null,
    async ({ eventId, videoId, code }) => {
      const res = await apiClient.call("getRestrictedStreamingKey", {
        eventId,
        videoId,
        code,
      });
      if (!res.ok) {
        throw new Error("API error occurred.");
      }
      return res.data;
    }
  );
};
